var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1429 18.8539H19.5V9.74677C19.5 5.96731 16.7063 2.8441 13.0714 2.32445V1.28249C13.0714 0.690524 12.592 0.21106 12 0.21106C11.408 0.21106 10.9286 0.690524 10.9286 1.28249V2.32445C7.29375 2.8441 4.5 5.96731 4.5 9.74677V18.8539H3.85714C3.38304 18.8539 3 19.237 3 19.7111V20.5682C3 20.6861 3.09643 20.7825 3.21429 20.7825H9C9 22.4378 10.3446 23.7825 12 23.7825C13.6554 23.7825 15 22.4378 15 20.7825H20.7857C20.9036 20.7825 21 20.6861 21 20.5682V19.7111C21 19.237 20.617 18.8539 20.1429 18.8539ZM12 22.0682C11.2902 22.0682 10.7143 21.4923 10.7143 20.7825H13.2857C13.2857 21.4923 12.7098 22.0682 12 22.0682ZM6.42857 18.8539V9.74677C6.42857 8.25749 7.00714 6.85927 8.05982 5.8066C9.1125 4.75392 10.5107 4.17535 12 4.17535C13.4893 4.17535 14.8875 4.75392 15.9402 5.8066C16.9929 6.85927 17.5714 8.25749 17.5714 9.74677V18.8539H6.42857Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 5.5,
    r: 5.5,
    fill: "#FA8300"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOn);
export default __webpack_public_path__ + "static/media/bell-on.aba58c12.svg";
export { ForwardRef as ReactComponent };